const FirstMass=[
    {
        id:1,
        title:"Бульйон з куркою 250г",
        price:"94 грн",
        src: require('../img/chikensup.webp'),
        text:"Бульйон, філе куряче, локшина, яйце перепелине, зелень",
         allergy: `🥚яйце, 🌾глютен (локшина)  `
    },
    {
        id:2,
        title:"грибний крем-суп 250г",
        price:"140 грн",
        src: require('../img/mushsup.webp'),
        text:"печериці, цибуля ріпчаста, вершки, сухарики",
         allergy: `🥛молоко (вершки), 🌾глютен (сухарики), 🍄‍🟫гриби `
    },
    {
        id:3,
        title:"солянка м'ясна 250г",
        price:"150 грн",
        src: require('../img/solyanka.webp'),
        text:"мисливські ковбаски, бекон, огірки мариновані, цибуля ріпчаста, маслини, томати, лимон, сметана",
         allergy: `🥛молоко (сметана),🍋цитрус `
    },
    // {
    //     id:4,
    //     title:"Окрошка 250г",
    //     price:"119 грн",
    //     src: require('../img/okroshka.png'),
    //     text:"Заправка для окрошки, огірок, редиска, шинка, яйце, цибуля зелена, кріп",
    // },
    
]

export default FirstMass;